export default "/static/dashboard/build/app/img/v2/3fe259a18f65636e7539ea765d4c1e8b.png";